import { HttpFactory,HttpRequestBuilder} from "utils/http";
import { xhrCache } from "utils/cache";
import { diInject } from "stores/diContext";


export class OrderService {

    @diInject("api") http: HttpFactory;

    /**
     * 提交普通订单
     * @param data
     */
    submitOrder(data) {
        return this.http.url('/checkout/order_and_pay2').post(data);
    }
    /**
     * 提交pos订单
     * @param data
     */
    submitPosOrder(data) {
        return this.http.url(`/checkout/pos_order_and_pay`).post(data);
    }
}


// WEBPACK FOOTER //
// ./src/Apps/ticketing/services/order.ts